import { useState } from "react";
import { apiFetch } from "../utils/api";
import { useAdminCategoriesContext } from "../hooks/useAdminCategoriesContext";
import { useAuthContext } from "../hooks/useAuthContext";
import ConfirmModal from "./ConfirmModal/ConfirmModal";
import IconButton from "./IconButton/IconButton";

const CategoryDetails = ({ category, onEdit }) => {
  const { dispatch } = useAdminCategoriesContext();
  const { user } = useAuthContext();
  const [showConfirm, setShowConfirm] = useState(false);

  const handleEditClick = (e) => {
    e.stopPropagation();
    onEdit(category);
  };

  const handleDeleteClick = (e) => {
    e.stopPropagation();
    setShowConfirm(true);
  };

  const handleConfirm = async () => {
    setShowConfirm(false);
    if (!user) return;

    const response = await apiFetch(`/api/admin/categories/${category._id}`, {
      method: "DELETE",
      headers: { Authorization: `Bearer ${user.token}` },
    });
    const json = await response.json();

    if (response.ok) {
      dispatch({ type: "DELETE_CATEGORY", payload: json });
    }
  };

  return (
    <>
      <div className="category-details">
        <h4>{category.translations.en}</h4>
        <p>
          <strong>Details: </strong>TBA
        </p>
        {Object.entries(category.translations).map(([locale, translation]) => (
          <p key={category._id + locale}>
            <strong>{locale}: </strong>
            {translation}
          </p>
        ))}
        <div className="category-details-actions">
          <IconButton icon="edit" onClick={handleEditClick} aria-label="Edit category" />
          <IconButton icon="delete" variant="danger" onClick={handleDeleteClick} aria-label="Delete category" />
        </div>
      </div>

      {showConfirm && (
        <ConfirmModal
          title={`Delete "${category.translations.en}"?`}
          message="This will permanently delete the category and all its items. This cannot be undone."
          confirmLabel="Delete"
          onConfirm={handleConfirm}
          onCancel={() => setShowConfirm(false)}
        />
      )}
    </>
  );
};

export default CategoryDetails;
